import React, { useState } from 'react';
import PropTypes from 'prop-types';
import ReactTooltip from 'react-tooltip';
import { ATTACHMENTS } from 'newJs/config';
import { FaIcon } from 'components/Icons';
import { getTooltipText, parseResponse } from './utils';
import { useAttachData } from 'providers/attachs-data';
import { useAttachsParams } from 'providers/attachs-params';
import { useAttachsState } from 'providers/attachs-state';
import Action from './Base';
import AttachLoader from 'components/Loader';
import {useGlobalProps} from "providers/global-props";
import useMessageStore from 'state/messageState';

const { CLICK_ACTIONS: { SAVE_TO_FILES_ALL }  } = ATTACHMENTS;

// XXX: Use separate custom hook for item state management?
const SaveAction = (props) => {
    const
        { actionName, children, ...rest } = props,
        [ itemState, setItemState ] = useState('notSaved'),
        [ linkToItemFolder, setLinkToItemFolder ] = useState(null),
        { apiHost, handleClick } = useAttachsParams(),
        { i18n: {attachments: i18n }} = useGlobalProps(),
        attachStore = useAttachsState(),
        { fullScreenMode, isSaved, setSaved } = attachStore,
        itemData = useAttachData(),
        { hashId } = itemData,
        isItemSaved = isSaved(actionName, hashId),
        toolTip = getTooltipText(i18n, actionName);
    const emlData = useMessageStore((state) => state.emlData);
    const {attachments} = emlData;

    React.useEffect(() => {
        ReactTooltip.rebuild();
    }, [itemState]);

    const saveItem = (e) => {
        // "Save All" - send array of attachments instead of single object
        const data = (actionName === SAVE_TO_FILES_ALL)
            ? attachments
            : itemData;
        e.stopPropagation();
        setItemState('isSaving');
        handleClick(actionName, data)
            .then((result) => {
                const {
                    hasError,
                    url = apiHost.contacts // Contacts API does not return url
                } = parseResponse(result);

                if (hasError) {
                    setItemState('isFailed');
                    return false;
                }
                setLinkToItemFolder(url);
                setItemState('isSaved');
                setSaved(actionName, hashId);
            })
            .catch(() => {
                // TODO: Verify this works
                setItemState('isFailed');
            });
    };

    if (itemState === 'isSaved' || isItemSaved) {
        return (
            <Action
                data-tip={toolTip.success}
                data-type='success'
                href={linkToItemFolder}
                rel='noopener noreferrer'
                onClick={(e) => e.stopPropagation()}
                target='_blank'
                {...rest}
            >
                <FaIcon name='FaCheckCircle' className='item-status-icon status-success' />
            </Action>
        );
    }
    if (itemState === 'notSaved') {
        return (
            <Action
                data-tip={toolTip.default}
                data-action={actionName}
                onClick={saveItem}
                {...rest}
            >
                {children}
            </Action>
        );
    }
    if (itemState === 'isSaving') {
        return (
            <Action
                as='div'
                className={props.className}
                data-tip={i18n.pleaseWaitSaving}
            >
                <AttachLoader size={fullScreenMode ? 'md' : 'sm'} />
            </Action>
        );
    }
    // isFailed
    return (
        <Action
            className={props.className}
            data-tip={toolTip.failed}
            data-type='error'
            onClick={saveItem}
        >
            <FaIcon className='item-status-icon status-failed' name='FaTimesCircle' />
        </Action>
    );
};

SaveAction.propTypes = {
    actionName: PropTypes.string.isRequired,
    className: PropTypes.string,
    children: PropTypes.node.isRequired
};

export default SaveAction;
